import { useEffect } from 'react'
import { useLoaderData } from 'react-router-dom'
import { useLoadSdkYuno } from '../../hooks'
import { EnrollmentRedirectConfig, UseEnrollmentRoute } from './enrollment-route.types'
import { getWhiteLabelOptions } from '../../utils/white-label'

export const useEnrollmentRoute: UseEnrollmentRoute = () => {
  const { customerSession, language, countryCode, publicApiKey } =
    useLoaderData() as EnrollmentRedirectConfig
  const { isYunoLoaded } = useLoadSdkYuno()

  const initSdk = async() => {
    const yuno = await window.SdkPayments.initialize(publicApiKey, undefined, getWhiteLabelOptions())

    await yuno.mountEnrollmentLite({
      customerSession,
      language,
      countryCode,
    } as any)
  }

  useEffect(() => {
    if (isYunoLoaded) {
      initSdk()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isYunoLoaded])
}
